import { Dropdown } from "@citi-icg-172888/icgds-react";
import { Size } from "@citi-icg-172888/icgds-react/Utils/util";
import _ from "lodash";
import React, { CSSProperties, useEffect } from "react";
import { detectZoom } from "../services/utils/utils";

interface IDropdownHocProps {
  name?: string;
  label?: string;
  options: string[];
  value: string | undefined;
  onChange: (value: string) => void;
  className?: string;
  WrapperClassName?: string;
  size?: Size;
  style?: CSSProperties;
  disabled?: boolean;
  placeholder?: string;
  ariaLabelledBy?: string;
  iconProps?: React.HTMLAttributes<HTMLElement>; // Added iconProps property
}

const DropdownHoc: React.FC<IDropdownHocProps> = ({
  name,
  label,
  options = [],
  value,
  onChange,
  className,
  size,
  style,
  WrapperClassName,
  disabled,
  ariaLabelledBy,
  placeholder,
  iconProps,
}) => {

  useEffect(() => {
    const zoom = detectZoom();
    console.log("Current Zoom Level:", zoom); // Log zoom level
  }, []);
  
  return (
    <div className={WrapperClassName}>
      {label && <label className="lmn-form-label lmn-d-block">{label}</label>}
      <Dropdown
        placeholder={placeholder || ""}
        className={className}
        onChange={(val) => {
          onChange(val as string);
        }}
        value={value}
        disabled={disabled}
        aria-label={ariaLabelledBy}
        style={style}
        name={name}
        data-cv-tracking-id="dropdown-tracking-id"
        size={size || "default"}
        aria-hidden={iconProps?.["aria-hidden"]} // Added to ensure decorative elements are ignored by screen readers
        aria-labelledby={ariaLabelledBy} // Added to ensure the dropdown is accessible
      >
        {options.length > 0 &&
          _.map(options, (i, index) => (
            <Dropdown.Item
              key={i}
              value={i}
              aria-labelledby={i}
              data-cv-tracking-id={`dropdown-item${index}-tracking-id`}
            >
              {i}
            </Dropdown.Item>
          ))}
      </Dropdown>
    </div>
  );
};

export default DropdownHoc;
